var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 16,
    viewBox: "0 0 97 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_2628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50005 11.5135L11.2667 13.1868C11.7734 13.4935 12.3934 13.0402 12.26 12.4668L11.5267 9.32017L13.9734 7.20017C14.42 6.8135 14.18 6.08017 13.5934 6.0335L10.3734 5.76017L9.11338 2.78684C8.88671 2.24684 8.11338 2.24684 7.88671 2.78684L6.62671 5.7535L3.40672 6.02684C2.82005 6.0735 2.58005 6.80684 3.02672 7.1935L5.47338 9.3135L4.74005 12.4602C4.60672 13.0335 5.22671 13.4868 5.73338 13.1802L8.50005 11.5135Z",
    fill: "#FFA924"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_131_2628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 11.5135L31.2667 13.1868C31.7734 13.4935 32.3934 13.0402 32.26 12.4668L31.5267 9.32017L33.9734 7.20017C34.42 6.8135 34.18 6.08017 33.5934 6.0335L30.3734 5.76017L29.1134 2.78684C28.8867 2.24684 28.1134 2.24684 27.8867 2.78684L26.6267 5.7535L23.4067 6.02684C22.82 6.0735 22.58 6.80684 23.0267 7.1935L25.4734 9.3135L24.74 12.4602C24.6067 13.0335 25.2267 13.4868 25.7334 13.1802L28.5 11.5135Z",
    fill: "#FFA924"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_131_2628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5 11.5135L51.2667 13.1868C51.7734 13.4935 52.3934 13.0402 52.26 12.4668L51.5267 9.32017L53.9734 7.20017C54.42 6.8135 54.18 6.08017 53.5934 6.0335L50.3734 5.76017L49.1134 2.78684C48.8867 2.24684 48.1134 2.24684 47.8867 2.78684L46.6267 5.7535L43.4067 6.02684C42.82 6.0735 42.58 6.80684 43.0267 7.1935L45.4734 9.3135L44.74 12.4602C44.6067 13.0335 45.2267 13.4868 45.7334 13.1802L48.5 11.5135Z",
    fill: "#FFA924"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_131_2628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.5 11.5135L71.2667 13.1868C71.7734 13.4935 72.3934 13.0402 72.26 12.4668L71.5267 9.32017L73.9734 7.20017C74.42 6.8135 74.18 6.08017 73.5934 6.0335L70.3734 5.76017L69.1134 2.78684C68.8867 2.24684 68.1134 2.24684 67.8867 2.78684L66.6267 5.7535L63.4067 6.02684C62.82 6.0735 62.58 6.80684 63.0267 7.1935L65.4734 9.3135L64.74 12.4602C64.6067 13.0335 65.2267 13.4868 65.7334 13.1802L68.5 11.5135Z",
    fill: "#FFA924"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_131_2628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.5 11.5135L91.2667 13.1868C91.7734 13.4935 92.3934 13.0402 92.26 12.4668L91.5267 9.32017L93.9734 7.20017C94.42 6.8135 94.18 6.08017 93.5934 6.0335L90.3734 5.76017L89.1134 2.78684C88.8867 2.24684 88.1134 2.24684 87.8867 2.78684L86.6267 5.7535L83.4067 6.02684C82.82 6.0735 82.58 6.80684 83.0267 7.1935L85.4734 9.3135L84.74 12.4602C84.6067 13.0335 85.2267 13.4868 85.7334 13.1802L88.5 11.5135Z",
    fill: "#FFA924"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_2628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_131_2628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(20.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_131_2628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(40.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_131_2628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(60.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_131_2628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(80.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.c6ce515c61d5ddbd03c58074b13edb4b.svg";
export { ForwardRef as ReactComponent };